// 旧APIが発行したトークンによるパスワード再設定。API停止に伴い利用できない
// （再設定はFirebase標準のメールリンクから行う）
import { rejectServiceClosed } from 'api/errors';

interface PatchPasswordSettingRequest {
  id: string;
  token: string;
  password: string;
}

export const usePasswordSetting = () => {
  const patchPasswordSetting = (_data: PatchPasswordSettingRequest): Promise<void> => rejectServiceClosed();

  return { patchPasswordSetting };
};
